import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import App from './App';

import reportWebVitals from './reportWebVitals';

import { DeviceContextProvider } from './context/DeviceContext';
import { PlatformContextProvider } from './context/PlatformContext';
import { UserContextProvider } from "./context/UserContext";
import { SubjectsMetadataContextProvider } from "./context/SubjectsMetadataContext";
import { OAuthContextProvider } from './context/OAuthContext';




const AppInitializer = () => {

  return (
    <React.StrictMode>
      <DeviceContextProvider>
        <UserContextProvider>
          <SubjectsMetadataContextProvider>
            <PlatformContextProvider>
              <OAuthContextProvider>
                <App />
              </OAuthContextProvider>
            </PlatformContextProvider>
          </SubjectsMetadataContextProvider>
        </UserContextProvider>
      </DeviceContextProvider>
    </React.StrictMode>
  );
};





const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Append the App to the Root (alt can do ReactDOM.render and pass in "root")
root.render( <AppInitializer /> );
  /* NOTES OF STRICT MODE:
    - In Development Mode (ONLY) will intentionally Render Components twice (to reveal Side Effects, which the React Philosophy doesn't allow, since should be Idempotent) -- See https://stackoverflow.com/questions/48846289/why-is-my-react-component-is-rendering-twice
  */
 /*
  <React.StrictMode>
    <UserContextProvider>
      <SubjectsMetadataContextProvider>
        <App />
      </SubjectsMetadataContextProvider>
    </UserContextProvider>
  </React.StrictMode>
);
*/







// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
